<template>
  <el-container class="screen-container1">
    <!-- 左侧数据面板 -->
    <el-aside class="left-panel">
      <!-- 1. 探头状态统计 -->
      <div class="panel-card probe-card">
        <div class="probe-row">
          <div class="probe-item">
            <span class="probe-icon normal"></span>
            <span class="probe-label">正常探头</span>
            <span class="probe-num">938</span>
          </div>
          <div class="probe-item">
            <span class="probe-icon alarm"></span>
            <span class="probe-label">报警探头</span>
            <span class="probe-num">0</span>
          </div>
        </div>
        <div class="probe-row">
          <div class="probe-item">
            <span class="probe-icon fault"></span>
            <span class="probe-label">故障探头</span>
            <span class="probe-num">1</span>
          </div>
          <div class="probe-item">
            <span class="probe-icon overtime"></span>
            <span class="probe-label">超时探头</span>
            <span class="probe-num">2</span>
          </div>
        </div>
        <div class="rate-group">
          <div class="rate-item">
            <span class="rate-label">正常率</span>
            <div class="rate-bar">
              <div class="rate-fill" style="width: 95%"></div>
            </div>
            <span class="rate-value">95%</span>
          </div>
          <div class="rate-item">
            <span class="rate-label">故障率</span>
            <div class="rate-bar">
              <div class="rate-fill fault" style="width: 2%"></div>
            </div>
            <span class="rate-value">2%</span>
          </div>
          <div class="rate-item">
            <span class="rate-label">报警率</span>
            <div class="rate-bar">
              <div class="rate-fill alarm" style="width: 2%"></div>
            </div>
            <span class="rate-value">2%</span>
          </div>
          <div class="rate-item">
            <span class="rate-label">超时率</span>
            <div class="rate-bar">
              <div class="rate-fill overtime" style="width: 1%"></div>
            </div>
            <span class="rate-value">1%</span>
          </div>
        </div>
      </div>

      <!-- 2. 重大危险源等级柱状图 -->
      <div class="panel-card chart-card">
        <div class="panel-title">
          <span class="title-arrow"></span>
          重大危险源等级数量分析
          <span class="title-sub">危险源共 22 个</span>
        </div>
        <div ref="hazardChartRef" class="chart-box"></div>
      </div>

      <!-- 3. 报警类型环形图 -->
      <div class="panel-card chart-card">
        <div class="panel-title">
          <span class="title-arrow"></span>
          监测报警类型统计
          <span class="title-sub">报警共 211 条</span>
        </div>
        <div ref="alarmChartRef" class="chart-box"></div>
      </div>
    </el-aside>
    <!-- 中间厂区GIS地图 -->
    <el-main class="map-panel">
      <!-- 厂区底图 -->
      <div class="factory-map">
        <!-- 厂区建筑/道路背景 -->
        <img :src="require(`../assets/images/map.png`)" width="100%"></img>

        <!-- 区域标注 -->
        <div class="area-tag area-green" style="left: 38%; top: 22%">
          <span>6#装置</span>
          <span class="area-sub">探头 234个</span>
        </div>
        <div class="area-tag area-orange" style="left: 40%; top: 55%">
          <span>8#装置</span>
          <span class="area-sub">探头 234个</span>
        </div>
        <div class="area-tag area-red" style="left: 62%; top: 42%">
          <span>3#装置</span>
          <span class="area-sub">探头 234个</span>
        </div>

        <!-- 监测点位 -->
        <div
          v-for="(point, idx) in pointList"
          :key="idx"
          class="map-point"
          :class="[point.type, { alarm: point.isAlarm }]"
          :style="{ left: point.x + '%', top: point.y + '%' }"
          @mouseenter="showPointPopup(point, $event)"
          @mouseleave="hidePointPopup"
        >
          <span class="point-icon"></span>
        </div>

        <!-- 点位详情弹窗 -->
        <div v-show="popupVisible" class="point-popup" :style="popupStyle">
          <div class="popup-header">监测点详情</div>
          <div class="popup-table">
            <div class="popup-row header">
              <span>监测点名称</span>
              <span>类型</span>
              <span>数值</span>
              <span>状态</span>
            </div>
            <div v-for="(item, i) in popupData" :key="i" class="popup-row">
              <span>{{ item.name }}</span>
              <span>{{ item.type }}</span>
              <span>{{ item.value }}</span>
              <span :class="['status', item.status]">{{
                item.statusText
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧地图控件 -->
      <div class="map-controls">
        <div class="ctrl-btn" @click="zoomIn">+</div>
        <div class="ctrl-btn" @click="zoomOut">−</div>
        <div class="ctrl-btn" @click="refreshMap">↻</div>
        <div class="ctrl-btn ctrl-bottom">地名</div>
      </div>
    </el-main>
  </el-container>
</template>

<script setup lang="js">
import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue'
// 改用按需引入，解决重复注册冲突
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'

// 图表DOM引用
const hazardChartRef = ref(null)
const alarmChartRef = ref(null)
let hazardChart = null
let alarmChart = null

// 点位弹窗、模拟数据保持不变...

// 初始化危险源柱状图（增加单例判断）
const initHazardChart = async () => {
  await nextTick()
  if (!hazardChartRef.value) return
  if (hazardChart) {
    hazardChart.resize()
    return
  }
  hazardChart = echarts.init(hazardChartRef.value)
  const option = {
    backgroundColor: 'transparent',
    grid: { left: 30, right: 20, top: 20, bottom: 30 },
    xAxis: {
      type: 'category',
      data: ['一级', '二级', '三级', '四级'],
      axisLine: { lineStyle: { color: '#2c3c58' } },
      axisLabel: { color: '#a0b4d8', fontSize: 12 }
    },
    yAxis: {
      type: 'value',
      max: 20,
      interval: 5,
      axisLine: { lineStyle: { color: '#2c3c58' } },
      splitLine: { lineStyle: { color: '#1a2b4f', type: 'dashed' } },
      axisLabel: { color: '#a0b4d8', fontSize: 12 }
    },
    series: [{
      type: 'bar',
      barWidth: 16,
      data: [
        { value: 5, itemStyle: { color: '#f56c6c' } },
        { value: 10, itemStyle: { color: '#e6a23c' } },
        { value: 15, itemStyle: { color: '#f5d76e' } },
        { value: 20, itemStyle: { color: '#409eff' } }
      ]
    }]
  }
  hazardChart.setOption(option)
}

// 初始化报警环形图（增加单例判断）
const initAlarmChart = async () => {
  await nextTick()
  if (!alarmChartRef.value) return
  if (alarmChart) {
    alarmChart.resize()
    return
  }
  alarmChart = echarts.init(alarmChartRef.value)
  const option = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'item' },
    legend: {
      orient: 'vertical',
      right: 10,
      top: 'center',
      itemWidth: 12,
      itemHeight: 12,
      textStyle: { color: '#a0b4d8', fontSize: 12 },
      data: ['超高报', '高报', '低报', '超低报', '满量程']
    },
    series: [{
      type: 'pie',
      radius: ['55%', '75%'],
      center: ['30%', '50%'],
      avoidLabelOverlap: false,
      label: {
        show: true,
        position: 'center',
        formatter: '{a|报警总数}\n{b|211}',
        rich: {
          a: { color: '#a0b4d8', fontSize: 12, lineHeight: 20 },
          b: { color: '#fff', fontSize: 24, fontWeight: 'bold' }
        }
      },
      data: [
        { value: 24, name: '超高报', itemStyle: { color: '#f56c6c' } },
        { value: 30, name: '高报', itemStyle: { color: '#e6a23c' } },
        { value: 40, name: '低报', itemStyle: { color: '#409eff' } },
        { value: 123, name: '超低报', itemStyle: { color: '#67c23a' } },
        { value: 123, name: '满量程', itemStyle: { color: '#722ed1' } }
      ]
    }]
  }
  alarmChart.setOption(option)
}

// 窗口自适应
const resizeCharts = () => {
  hazardChart?.resize()
  alarmChart?.resize()
}

onMounted(async () => {
  await initHazardChart()
  await initAlarmChart()
  window.addEventListener('resize', resizeCharts)
})

onUnmounted(() => {
  window.removeEventListener('resize', resizeCharts)
  // 彻底销毁并置空
  if (hazardChart) {
    hazardChart.dispose()
    hazardChart = null
  }
  if (alarmChart) {
    alarmChart.dispose()
    alarmChart = null
  }
})
</script>

<style>
/* 全屏容器 */
.screen-container1 {
  height: 100%;
  overflow: hidden;
  background: #050b1f;
  position: relative;
  /* display: flex;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  background: radial-gradient(
      circle at top left,
      rgba(64, 158, 255, 0.12),
      transparent 35%
    ),
    linear-gradient(135deg, #050b1f 0%, #0a101f 50%, #050b1f 100%);
  color: #fff;
  font-family: "Microsoft YaHei", Arial, sans-serif; */
}

/* 左侧面板 */
.left-panel {
  height: 100%;
  width: 360px !important;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;
  position: absolute;
  z-index: 999;
}

/* 通用卡片 */
.panel-card {
  background: rgba(14, 22, 41, 0.85);
  border: 1px solid rgba(64, 158, 255, 0.25);
  border-radius: 6px;
  padding: 16px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
}

/* 探头统计卡片 */
.probe-card .probe-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}
.probe-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}
.probe-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.probe-icon.normal {
  background: #67c23a;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 50% 100%, 0 70%);
}
.probe-icon.alarm {
  background: #f56c6c;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}
.probe-icon.fault {
  background: #e6a23c;
  clip-path: polygon(
    0 20%,
    40% 20%,
    40% 0,
    60% 0,
    60% 20%,
    100% 20%,
    100% 80%,
    60% 80%,
    60% 100%,
    40% 100%,
    40% 80%,
    0 80%
  );
}
.probe-icon.overtime {
  background: #f5d76e;
  border-radius: 2px;
}
.probe-label {
  font-size: 14px;
  color: #d0dcf0;
}
.probe-num {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin-left: auto;
}

/* 比率进度条 */
.rate-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.rate-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.rate-label {
  width: 50px;
  font-size: 12px;
  color: #a0b4d8;
}
.rate-bar {
  flex: 1;
  height: 6px;
  background: rgba(64, 158, 255, 0.15);
  border-radius: 3px;
  overflow: hidden;
}
.rate-fill {
  height: 100%;
  background: #409eff;
  border-radius: 3px;
}
.rate-fill.fault {
  background: #e6a23c;
}
.rate-fill.alarm {
  background: #f56c6c;
}
.rate-fill.overtime {
  background: #f5d76e;
}
.rate-value {
  width: 40px;
  text-align: right;
  font-size: 12px;
  color: #409eff;
}

/* 图表卡片标题 */
.panel-title {
  font-size: 15px;
  color: #d0dcf0;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-arrow {
  width: 4px;
  height: 14px;
  background: linear-gradient(180deg, #409eff, #00c8ff);
  border-radius: 2px;
}
.title-sub {
  margin-left: auto;
  font-size: 13px;
  color: #409eff;
  font-weight: normal;
}
.chart-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.chart-box {
  flex: 1;
  width: 100%;
  min-height: 180px;
}

/* 中间地图区域 */
.map-panel {
  height: 100%;
  position: relative;
  min-width: 0;
  overflow: hidden;
  padding: 0 !important;
}
.factory-map {
  width: 100%;
  height: 100%;
  position: relative;
  border: 1px solid rgba(64, 158, 255, 0.25);
  border-radius: 6px;
  overflow: hidden;
  background: #0a101f;
}

/* 厂区底图模拟 */
.map-bg {
  width: 100%;
  height: 100%;
  background-image: url(../assets/images/map.png);
  position: absolute;
  left: 0;
  top: 0;
}

/* 区域标注框 */
.area-tag {
  position: absolute;
  transform: translate(-50%, -50%);
  padding: 8px 16px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.area-tag .area-sub {
  font-size: 12px;
  font-weight: normal;
  opacity: 0.9;
}
.area-green {
  background: rgba(103, 194, 58, 0.2);
  border: 2px solid #67c23a;
  color: #67c23a;
}
.area-orange {
  background: rgba(230, 162, 60, 0.2);
  border: 2px solid #e6a23c;
  color: #e6a23c;
}
.area-red {
  background: rgba(245, 108, 108, 0.2);
  border: 2px solid #f56c6c;
  color: #f56c6c;
  box-shadow: 0 0 20px rgba(245, 108, 108, 0.4);
}

/* 地图点位 */
.map-point {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 3;
  cursor: pointer;
}
.point-icon {
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #409eff;
  border: 2px solid #fff;
  box-shadow: 0 0 8px rgba(64, 158, 255, 0.6);
}
.map-point.group .point-icon {
  background: #67c23a;
}
.map-point.gas .point-icon {
  background: #722ed1;
}
.map-point.pressure .point-icon {
  background: #13c2c2;
}
.map-point.level .point-icon {
  background: #e6a23c;
}
.map-point.temp .point-icon {
  background: #f5d76e;
}
.map-point.video .point-icon {
  background: #409eff;
}
.map-point.danger .point-icon {
  background: #f56c6c;
}
.map-point.alarm .point-icon {
  background: #f56c6c;
  animation: pointPulse 1.5s infinite;
}
.map-point.warn .point-icon {
  background: #e6a23c;
}
.map-point.device .point-icon {
  background: #909399;
}

@keyframes pointPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.6);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 108, 108, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

/* 点位弹窗 */
.point-popup {
  position: fixed;
  z-index: 999;
  background: rgba(14, 22, 41, 0.95);
  border: 1px solid rgba(64, 158, 255, 0.35);
  border-radius: 6px;
  padding: 12px;
  min-width: 280px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}
.popup-header {
  font-size: 14px;
  color: #409eff;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(64, 158, 255, 0.2);
}
.popup-table {
  font-size: 12px;
}
.popup-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1.2fr 1fr;
  gap: 8px;
  padding: 6px 0;
  color: #d0dcf0;
}
.popup-row.header {
  color: #a0b4d8;
  font-weight: 500;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.status.superHigh {
  color: #f56c6c;
}
.status.high {
  color: #e6a23c;
}
.status.low {
  color: #409eff;
}
.status.fault {
  color: #f5d76e;
}
.status.offline {
  color: #909399;
}

/* 右侧地图控件 */
.map-controls {
  position: absolute;
  right: 16px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 10;
}
.ctrl-btn {
  width: 36px;
  height: 36px;
  background: rgba(14, 22, 41, 0.9);
  border: 1px solid rgba(64, 158, 255, 0.3);
  border-radius: 4px;
  color: #d0dcf0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  transition: 0.2s;
}
.ctrl-btn:hover {
  background: rgba(64, 158, 255, 0.2);
  color: #409eff;
}
.ctrl-bottom {
  font-size: 12px;
}
</style>
